import { Fragment, type ReactNode } from 'react'
import { cn } from '@/lib/utils'

const URL_SPLIT = /(https?:\/\/[^\s]+)/g

function linkifyLine(line: string): ReactNode[] {
  const parts = line.split(URL_SPLIT)
  return parts.map((part, i) => {
    if (/^https?:\/\//.test(part)) {
      return (
        <a
          key={i}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
          className="font-medium text-[#1CB5C8] underline underline-offset-2 break-all hover:opacity-90"
          onClick={(e) => e.stopPropagation()}
        >
          {part}
        </a>
      )
    }
    return <Fragment key={i}>{part}</Fragment>
  })
}

export interface TextWithLinksProps {
  text: string
  className?: string
}

/** Affiche du texte multiligne avec URLs http(s) cliquables. */
export function TextWithLinks({ text, className }: TextWithLinksProps) {
  const lines = text.split('\n')
  return (
    <div className={cn('break-words', className)}>
      {lines.map((line, idx) => (
        <span key={idx}>
          {idx > 0 ? <br /> : null}
          {linkifyLine(line)}
        </span>
      ))}
    </div>
  )
}
